'use client';

import { Carousel, CarouselItem, Grid, GridItem } from '@coolblue-development/freddy';
import { useFreddyTranslations } from '@coolblue-development/next-design-system-utils/client';
import { AccessoryEntrance } from '@features/accessory-categories/types';

import { AccessoryCard } from './AccessoryCard';

type Props = {
  accessoryCategories: AccessoryEntrance[];
};

export default function AccessoryEntrancesBase({ accessoryCategories }: Props) {
  const carouselTranslations = useFreddyTranslations('carousel');

  return (
    <>
      <Grid gap={400} hideUntil='md'>
        {accessoryCategories.map((item, index) => (
          <GridItem column={{ md: 'span 3' }} key={index}>
            <AccessoryCard
              fragment={item.fragment}
              url={item.url}
              totalCategories={item.totalCategories}
              index={index}
            />
          </GridItem>
        ))}
      </Grid>

      <Carousel
        hideFrom='md'
        itemsInView={{
          xs: 1.5,
          sm: 2.4
        }}
        hideNavigation
        fullWidthUntil='md'
        translations={carouselTranslations}
      >
        {accessoryCategories.map((item, index) => (
          <CarouselItem key={index}>
            <AccessoryCard
              fragment={item.fragment}
              url={item.url}
              totalCategories={item.totalCategories}
              index={index}
            />
          </CarouselItem>
        ))}
      </Carousel>
    </>
  );
}
